module.exports = __webpack_public_path__ + "img/City Wash.59879c99.svg";